import { useState } from "react";
import InventoryStockService from "../../../api/Inventory/InventoryStockService";
import useLoading from "../../../components/Common/useLoading";
import { AssignmentType } from "../../../api/Inventory/Entities/InventoryEntities";

function propsTemplate() {
    return {
        intentoryItemId: 0,
        releaseId: 0,
        assignmentType: AssignmentType.General.Name,
        assignId: null,
        excludeExpired: true
    }
}

export default function useReleaseStockByAssignment(props = propsTemplate()) {
    const [stockList, setPagedStock] = useState([])
    const [isLoading, load, reload] = useLoading({
        onLoad: async () => {
            await Find(props)
        },
    })

    const Navigation = {
        Search: async (props = propsTemplate()) => load(async () => {
            await Find(props)
        }),
        Reload: reload
    }

    async function Find(props) {
        const result = await InventoryStockService.FindStockQuantity({ ...props })
        setPagedStock(result.Value)
    }

    return [stockList, isLoading, Navigation]
}